import { ContactUsIf, RegisterIf } from "interfaces/contactIf";
import contactService from "services/contactServices";

export function registerBusiness (values) {
    return async (dispatch) => {
        try {
            const data = new RegisterIf(values);
            const resp = contactService.registerBusiness(data);
            return resp;
        } catch ( error ) {
            // console.log("Error in registration ", error);
        }
    }
}

export function contactUs (values) {
    return async (dispatch) => {
        const data = new ContactUsIf(values);        
        try {
            const resp = contactService.contactUs(data);
            return resp;
        } catch ( error ) {
            // console.log("Error in registration ", error);
        }
    }
}

export function deleteAccountOTPReq (appName, mobile) {
    return async (dispatch) => {
        console.log("deleteAccountOTPReq() ", appName, mobile);
        try {
            const resp = contactService.deleteAccountOTPReq(appName, mobile);
            return resp;
        } catch ( error ) {
            // console.log("Error in registration ", error);
        }
    }
}

export function deleteAccountOTPConfirm (appName, mobile, otp) {
    return async (dispatch) => {

        console.log("deleteAccountOTPConfirm() ", appName, mobile, otp);
        try {
            const resp = contactService.deleteAccountOTPConfirm(appName, mobile, otp);
            return resp;
        } catch ( error ) {
            // console.log("Error in registration ", error);
        }
    }
}






